<template>
  <div>
    <div class='h-track-nopadding' :class='checkBoxClassObject' v-for='(option, index) in data.datasource' :key='index'>
      <ejs-checkbox
        :value='option.value'
        :label='option.showName'
        :name='option.name'
        :checked='option.checked'
        :id='option.realName'
        :disabled='option.disabled'
        @change="checkChange"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCheckBox',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    defaultData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    checkBoxClassObject() {
      switch (Number(this.data.colShowSize)) {
        case 1: return 'col-sm-12';
        case 2: return 'col-sm-6';
        case 3: return 'col-sm-4';
        case 4: return 'col-sm-3';
        case 6: return 'col-sm-2';
        case 12: return 'col-sm-1';
        default: return 'col-sm-6';
      }
    }
  },
  created() {
    this.data.value = new Map();
  },
  beforeMount() {
    const data = JSON.stringify(this.defaultData) !== '{}' ? JSON.parse(this.defaultData.paramsJson) : '';
    for (let i = 0; i < this.data.datasource.length; i++) {
      if (data[this.data.datasource[i].realName]) {
        this.data.datasource[i].checked = true;
      }
      this.data.datasource[i].disabled = !(JSON.stringify(this.defaultData) === '{}');
      this.data.disabled = JSON.stringify(this.defaultData) !== '{}' ? true : !this.data.enabled;
    }
  },
  methods: {
    checkChange(event) {
      const $this = this;
      const flag = event.checked;
      if (this.data.changeName) {
        const map = new Map(this.data.changeName);
        const nameArr = map.get(event.event.target.id);
        nameArr.forEach(item => {
          const obj = document.getElementsByName(item)[0];
          if (obj.type == 'textarea') {
            obj.disabled = flag;
          } else if (obj.type == 'text') {
            obj.ej2_instances[0].enabled = !flag;
          }
          if (flag && document.getElementById(item+'-info')) {
            document.getElementById(item+'-info').setAttribute('style', 'display: none');
          }
        });
        this.$emit('validateUpdate', nameArr, flag ? "remove" : "add");
      }
      if (flag) {
        // $this.data.value.clear();
        $this.data.value.set(event.event.target.id, event.event.target.value);
        console.log("map", $this.data.value);
      } else {
        $this.data.value.delete(event.event.target.id);
      }
    },
  }
};
</script>
